"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import SecurityServicesTabs from "@/components/pageTabs/securityServicesTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import InclusionComp from "./components/inclusion";
import TrustFactors from "./components/trustFactors";
import Intro from "./components/intro";
import OfferingsComp from "./components/offerings";
import WorkComp from "./components/works";

const CloudSecurityPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout>
        <SecurityServicesTabs />
        <Intro />
      </PageLayout>
      <Box my={16}>
        <InclusionComp />
      </Box>
      <PageLayout>
        <WorkComp />
      </PageLayout>
      <Box my={16}>
        <OfferingsComp />
      </Box>
      <PageLayout showContactForm>
        <TrustFactors />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default CloudSecurityPage;
